import React from "react";
import useIcons from "../../../hooks/useIcons";
import {iconNames} from "../../../constants/icon-names";

const ActionButtons = ({ isEditing, onSave, onCancel, onEdit }) => {
  const { getIcon } = useIcons();

  return isEditing ? (
    <div className="d-flex">
      <button onClick={onSave} className="button-icontrigger m-r-spacer save">
        <span>{getIcon(iconNames.SAVE)}</span>
      </button>
      <button
        onClick={onCancel}
        className="button-icontrigger modal-closetrigger"
      >
        <span className="icon">{getIcon(iconNames.CROSS)}</span>
      </button>
    </div>
  ) : (
    <button className="button-icontrigger caption" type="button" onClick={onEdit}>
      <span className="icon">
        {getIcon(iconNames.EDIT)}
      </span>
      Редактировать
    </button>
  );
};

export default ActionButtons;
